import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DemoPage from './pages/DemoPage';
import AboutPage from './pages/AboutPage';
import PriceListPage from './pages/PriceListPage';
import ProductsPage from './pages/ProductsPage';
import { 
  ServicesPage, 
  CateringPage, 
  EventsPage, 
  MenuTastingPage, 
  ConsultingPage 
} from './pages/services';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/nosotros" element={<AboutPage />} />
          <Route path="/productos" element={<ProductsPage />} />
          <Route path="/precios" element={<PriceListPage />} />
          <Route path="/servicios" element={<ServicesPage />} />
          <Route path="/servicios/catering" element={<CateringPage />} />
          <Route path="/servicios/eventos" element={<EventsPage />} />
          <Route path="/servicios/menu-degustacion" element={<MenuTastingPage />} />
          <Route path="/servicios/consultoria" element={<ConsultingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
